<script lang="ts">
    import { currentView, error, success, isAuthenticated } from "./stores";
    import { apiClient } from "./apiClient";
    import Router, { link } from "svelte-spa-router";
    import { routes } from "./routes";
    import { SvelteToast, toast } from "@zerodevx/svelte-toast";
    import Login from "./Login.svelte";

    // Clear messages when view changes
    $: if ($currentView) {
        error.set(null);
        success.set(null);
    }

    // Show toasts for error and success messages
    $: if ($error) {
        toast.push($error, {
            theme: {
                "--toastColor": "mintcream",
                "--toastBackground": "rgba(220, 53, 69, 0.9)",
                "--toastBarBackground": "#dc3545",
            },
        });
        error.set(null); // Clear after showing
    }

    $: if ($success) {
        toast.push($success, {
            theme: {
                "--toastColor": "white",
                "--toastBackground": "rgba(40, 167, 69, 0.9)",
                "--toastBarBackground": "#28a745",
            },
        });
        success.set(null); // Clear after showing
    }

    const toastOptions = {
        intro: { y: 256 },
        duration: 4000,
    };

    function handleLogout() {
        apiClient.logout();
        isAuthenticated.set(false);
        success.set("Erfolgreich abgemeldet!");
    }
</script>

{#if !$isAuthenticated}
    <SvelteToast options={toastOptions} />
    <Login />
{:else}
    <main>
        <SvelteToast options={toastOptions} />
        <header class="header">
            <div class="container">
                <h1>🍹 Drinks Admin</h1>
                <nav class="nav">
                    <a
                        href="/drinks"
                        use:link
                        class="nav-button"
                        class:active={$currentView === "drinks"}
                    >
                        Drinks
                    </a>
                    <a
                        href="/categories"
                        use:link
                        class="nav-button"
                        class:active={$currentView === "categories"}
                    >
                        Categories
                    </a>
                    <a
                        href="/tags"
                        use:link
                        class="nav-button"
                        class:active={$currentView === "tags"}
                    >
                        Tags
                    </a>
                    <a
                        href="/tables"
                        use:link
                        class="nav-button"
                        class:active={$currentView === "tables"}
                    >
                        Tables
                    </a>
                    <a
                        href="/orders"
                        use:link
                        class="nav-button"
                        class:active={$currentView === "orders"}
                    >
                        Historic Orders
                    </a>
                    <button class="logout-button" on:click={handleLogout}>
                        Abmelden
                    </button>
                </nav>
            </div>
        </header>

        <div class="container">
            <Router {routes} />
        </div>
    </main>
{/if}

<style>
    :global(html) {
        overflow-y: scroll; /* Always show scrollbar to prevent layout shift */
    }

    :global(.nav-button.active) {
        background: #2c3e50 !important;
    }

    :global(.nav a) {
        padding: 10px 20px;
        background: #3498db;
        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s;
        text-decoration: none;
        display: inline-block;
        margin-right: 10px;
    }

    :global(.nav a:hover) {
        background: #2980b9;
        text-decoration: none;
    }

    :global(.nav a.active) {
        background: #2c3e50;
    }

    :global(.nav a:visited) {
        color: white;
    }

    .logout-button {
        padding: 10px 20px;
        background: #e74c3c;
        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s;
        text-decoration: none;
        display: inline-block;
        vertical-align: middle;
        line-height: 1.2;
        font-family: inherit;
        font-size: inherit;
        margin: 0;
    }

    .logout-button:hover {
        background: #c0392b;
    }
</style>
